import { MatchStatus } from "./match_v2";


export const translateMatchStatus = (status: MatchStatus): string => {
  switch (status) {
    case MatchStatus.SCHEDULED:
      return 'Agendado';
    case MatchStatus.FINISHED:
      return 'Encerrado';
    case MatchStatus.RUNNING:
      return 'Em andamento';
    case MatchStatus.POSTPONED:
      return 'Adiado';
    case MatchStatus.CANCELED:
      return 'Cancelado';
    case MatchStatus.SUSPENDED:
      return 'Suspenso';
    case MatchStatus.DELETED:
      return 'Deletado';
    case MatchStatus.DRAFT:
      return 'Rascunho';
    default:
      return status;
  }
};

export class Match {
  uuid!: string;
  match_date!: string;
  transmission!: string;
  round_uuid!: string;
  league_uuid!: string;
  league_name?: string;
  local!: string;
  home_team_uuid!: string;
  away_team_uuid!: string;
  home_team_name?: string;
  away_team_name?: string;
  home_team_image?: string;
  away_team_image?: string;
  home_goals!: number;
  away_goals!: number;
  status!: MatchStatus;
  created_at!: string;
  updated_at!: string;
  is_show_information?: boolean;
  hyperlink?: string;
  description?: string;
  is_last_matches?: boolean;
  last_matches?: {
    home_goals: number;
    away_goals: number;
    home_team_uuid: string;
    home_team_name: string;
    away_team_uuid: string;
    away_team_name: string;
  }[];
  is_history_matches?: boolean;
  history_matches?: {
    wins: number;
    draw: number;
    lose: number;
  };
}
